import { useState, useEffect } from 'react';
import { X, Users, ScrollText } from 'lucide-react';
import { UsersTab } from './manage/UsersTab';
import { AuditLogTab } from './manage/AuditLogTab';
type ManageTab = 'users' | 'audit-log';
interface ManageModalProps {
  onClose: () => void;
}
const TABS: {
  key: ManageTab;
  label: string;
  icon: React.ReactNode;
}[] = [{
  key: 'users',
  label: 'Users',
  icon: <Users size={16} data-id="element-331" data-mp="2m0ppe1wlc5vh" />
}, {
  key: 'audit-log',
  label: 'Audit Log',
  icon: <ScrollText size={16} data-id="element-332" data-mp="2lzxz96lrj0cl" />
}];
export function ManageModal({
  onClose
}: ManageModalProps) {
  const [activeTab, setActiveTab] = useState<ManageTab>('users');

  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);
  return <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto py-4 px-2" style={{
    background: 'rgba(0,0,0,0.55)'
  }} onClick={onClose} data-id="element-333" data-mp="wkq79vazv63p">
      <div className="relative bg-white rounded-xl shadow-2xl w-full flex flex-col" style={{
      maxWidth: '98vw',
      height: '95vh'
    }} onClick={e => e.stopPropagation()} data-id="element-334" data-mp="1sy6mfqpukhe9">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200" data-id="element-335" data-mp="1iyfthtgxqaga">
          <h2 className="text-lg font-semibold text-slate-900" data-id="element-336" data-mp="15716zcntjr4h">Manage</h2>
          <button onClick={onClose} className="p-1 rounded-md hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors" data-id="element-337" data-mp="19zatsjtn0b2j">
            <X size={20} data-id="element-338" data-mp="v81ybu31zvhh" />
          </button>
        </div>

        {/* Body: sidebar + content */}
        <div className="flex flex-1 min-h-0" data-id="element-339" data-mp="106mwlnyqw53a">
          {/* Left sidebar */}
          <nav className="w-48 border-r border-slate-200 bg-slate-50 flex-shrink-0" data-id="element-340" data-mp="ma001mapfgxw">
            <div className="py-3" data-id="element-341" data-mp="r7rrygbcn323">
              {TABS.map(tab => <button key={tab.key} onClick={() => setActiveTab(tab.key)} className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-medium transition-colors ${activeTab === tab.key ? 'bg-indigo-50 text-indigo-700 border-r-2 border-indigo-600' : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'}`} data-id="element-342" data-mp="2sxqkxiarbk8c">
                  {tab.icon}
                  {tab.label}
                </button>)}
            </div>
          </nav>

          {/* Content area */}
          <div className="flex-1 overflow-y-auto p-6" data-id="element-343" data-mp="32ttn2o5lziva">
            {activeTab === 'users' && <UsersTab data-id="element-344" data-mp="2xvs566jx5ple" />}
            {activeTab === 'audit-log' && <AuditLogTab data-id="element-345" data-mp="1rg7zh7fedpbv" />}
          </div>
        </div>
      </div>
    </div>;
}